/***
 *
 *   HEADER
 *   Header section with title used in main application (can render children)
 *
 *   PROPS
 *   title: title of the view
 *   children: children to render (optional)
 *
 **********/

import { AuthContext } from "app/auth";
import { ModalContext } from "app/app";
import axios from "axios";
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { IconedButton } from "components/IconedButton";
import Style from "./header.module.scss";

export function Header(props) {
  const location = useLocation();
  const Auth = useContext(AuthContext);
  const { setModal } = useContext(ModalContext);

  const checkDisabled = async () => {
    const agencyData = await axios.get("/api/account");

    if (agencyData.data.data.status === "total_disabled") {
      Auth.signout();
    } else {
      return false;
    }
  };

  useEffect(() => {
    checkDisabled();
  }, [location]);

  return (
    <header className={Style.header}>
      {props.title && (
        <div style={{ justifyContent: "flex-start" }}>
          <h1>
            COVER
            <span>BADGER</span>
          </h1>
        </div>
      )}

      {window && !window.location.toString().includes("/app/resources") && (
        <div className={Style.helpArea}>
          <div className={Style.quickActions}>
            <IconedButton
              size="220px"
              color="#d32425"
              textColor="white"
              icon="plus-circle"
              text="Run Commercial Quote"
              marginRight
              action={() =>
                setModal({
                  name: "run_quote_modal",
                })
              }
            />
          </div>
        </div>
      )}
      <div
        style={{ alignItems: "flex-end", backgroundColor: "black", zIndex: -1 }}
      >
        {props.children}
      </div>
    </header>
  );
}
